module.exports = __webpack_public_path__ + "static/media/grid.8b4a853a.svg";